import React from 'react';
import { Link } from 'react-router-dom';
import './Portal.css';

const Portal = () => {
  return (
    <div className="portal-container">
      <div className="portal-split portal-trading">
        <div className="portal-content">
          <h2>TQS Trading</h2>
          {/* <p>Quantitative systematic trading across diverse prediction markets.</p> */}
          <p>Quantitative sports trading and research.</p>
          <Link to="/trading" className="portal-btn">Enter TQS Trading</Link>
        </div>
      </div>
      <div className="portal-split portal-consulting">
        <div className="portal-content">
          <h2>TQS Consulting</h2>
          <p>Early career consulting for high school and college students.</p>
          <Link to="/consulting" className="portal-btn">Enter TQS Consulting</Link>
        </div>
      </div>
    </div>
  );
};

export default Portal;
